// Default site content — mirrors the original hardcoded copy.
// Admin edits are stored server-side and deep-merged over these defaults.

export const DEFAULT_CONTENT = {
  site: {
    title: "PRC Remit株式会社 | 決済アプリの、その先へ。",
    logo: "/prc-logo.png",
  },
  hero: {
    eyebrow: "[ SYS ] Global Payment Infrastructure",
    line1: "決済アプリの、",
    line2: "その先へ。",
    subtitle:
      "海外送金・電子決済・本人確認。PRC Remitは、世界とつながる次世代の資金移動インフラを、確かな信頼とともに設計します。",
    cta1_label: "サービスを見る",
    cta1_link: "/services",
    cta2_label: "お問い合わせ",
    cta2_link: "/contact",
    bg_image: "https://images.unsplash.com/photo-1625014618427-fbc980b974f5",
  },
  manifesto: {
    eyebrow: "// 01 — Our Philosophy / 企業理念",
    chapters: [
      {
        id: "m1",
        no: "01",
        title: "信頼を、基盤に。",
        body: "資金移動業として、厳格な本人確認と顧客管理を徹底。すべての取引を安全に守る設計思想が、私たちの原点です。",
        detail:
          "私たちは金融サービスの根幹が「信頼」であると考えています。犯罪収益移転防止法をはじめとする各種規制を遵守し、本人確認（KYC）と継続的な顧客管理を仕組みとして組み込むことで、不正利用やマネーロンダリングのリスクを最小化します。監査ログの保全、暗号化、アクセス制御を含む多層的なセキュリティにより、お客様の資金と情報を守り抜きます。",
      },
      {
        id: "m2",
        no: "02",
        title: "速さを、当たり前に。",
        body: "国境を越える送金を、シンプルかつ迅速に。最先端の電子決済システムで、待たせない体験を実現します。",
        detail:
          "従来の海外送金は、着金までに数日を要することも珍しくありませんでした。私たちは決済インフラを内製で設計・運営することで、処理の中間工程を極限まで削減。リアルタイムに近いスピードと、透明性の高い手数料体系を両立します。ユーザーがストレスなく使えることこそ、テクノロジーの本質だと考えています。",
      },
      {
        id: "m3",
        no: "03",
        title: "世界と、つながる。",
        body: "海外送金サービスの企画から運営まで一貫して手がけ、人とお金が自由に行き交う未来を支えます。",
        detail:
          "国や通貨の違いは、人々の可能性を制限するものであってはなりません。私たちは各地域のパートナーと連携し、対応通貨・対応国を継続的に拡大。モバイルアプリを起点に、いつでもどこでも、誰もが等しく金融サービスにアクセスできる世界を目指します。国境なき資金移動インフラの実現が、私たちの使命です。",
      },
    ],
  },
  services: {
    eyebrow: "// 02 — Services / 事業領域",
    heading: "資金の流れを、\n根本から設計する。",
    cards: [
      {
        id: "s1",
        icon: "Globe",
        tag: "01 / Remittance",
        title: "海外送金サービス",
        body: "国境を越える送金の企画・開発・運営・管理までを一貫して提供。スピードと透明性を両立します。",
        image: "https://images.unsplash.com/photo-1625014618427-fbc980b974f5",
        detail:
          "資金移動業者として、海外送金サービスの企画から開発・運営・管理までを自社で一貫して手がけます。中間工程を削減した独自の決済フローにより、従来数日を要した着金をリアルタイムに近い水準へ。為替や手数料も明朗に提示し、個人・法人を問わず安心して使える送金体験を提供します。",
        points: ["企画・開発・運営・管理までワンストップ", "リアルタイムに近い着金スピード", "透明性の高い手数料・為替表示"],
      },
      {
        id: "s2",
        icon: "CreditCard",
        tag: "02 / Payment",
        title: "電子決済システム",
        body: "安全で拡張性の高い電子決済基盤を設計・提供・運営します。",
        image: "",
        detail:
          "電子決済システムの企画・開発・提供・運営を通じて、事業者が安心して利用できる決済基盤を構築します。高可用性のアーキテクチャと多層的なセキュリティを備え、取引量の増加にも柔軟にスケール。API連携により、あらゆるサービスへスムーズに組み込めます。",
        points: ["高可用性・高スケーラビリティ設計", "多層防御のセキュリティ", "API連携による柔軟な組み込み"],
      },
      {
        id: "s3",
        icon: "Smartphone",
        tag: "03 / Mobile",
        title: "モバイルアプリ開発",
        body: "アプリケーション及びソフトウェアの企画・開発・提供・保守。",
        image: "https://images.pexels.com/photos/6406691/pexels-photo-6406691.jpeg",
        detail:
          "モバイルアプリケーション及びソフトウェアの企画・開発・提供・保守を担います。直感的なUI/UXと堅牢な実装を両立し、リリース後も継続的な改善・保守で品質を維持。ユーザーが日常的に触れる金融体験を、心地よく設計します。",
        points: ["直感的なUI/UX設計", "堅牢でセキュアな実装", "継続的な保守・改善"],
      },
      {
        id: "s4",
        icon: "ShieldCheck",
        tag: "04 / KYC",
        title: "本人確認・顧客管理",
        body: "厳格な本人確認業務と顧客管理システムの企画・運営で、コンプライアンスを支えます。",
        image: "",
        detail:
          "本人確認業務（KYC）及び顧客管理システムの企画・運営を通じて、コンプライアンス体制を根幹から支えます。犯罪収益移転防止法などの規制に準拠し、オンライン本人確認（eKYC）や継続的なモニタリングを仕組み化。不正利用のリスクを抑えつつ、正当な利用者にはスムーズな体験を提供します。",
        points: ["eKYCによるオンライン本人確認", "継続的な顧客モニタリング", "各種規制への準拠"],
      },
    ],
  },
  works: {
    eyebrow: "// 05 — Works / 開発実績",
    heading: "つくってきたものが、\n信頼になる。",
    description: "資金移動・電子決済・本人確認の領域で手がけてきた開発実績の一部をご紹介します。",
  },
  company: {
    eyebrow: "// 03 — Company / 会社概要",
    heading: "確かな組織で、\n信頼を築く。",
    portrait: "/company-portrait.png",
    logo_image: "/prc-logo.png",
    logo_desc:
      "上昇する矢印とネットワークノードは、テクノロジーで加速する資金の流れと、世界をつなぐPRC Remitの信頼のインフラを象徴しています。",
    info: [
      { id: "i1", label: "商号", value: "PRC Remit株式会社" },
      { id: "i2", label: "本店所在地", value: "三重県津市高洲町23番25号" },
      { id: "i3", label: "代表取締役", value: "黒崎 龍一" },
      { id: "i4", label: "電話番号", value: "059-212-0393" },
      { id: "i5", label: "FAX番号", value: "050-6863-6004" },
      { id: "i6", label: "資本金", value: "100万円" },
      { id: "i7", label: "発行済株式総数", value: "100株" },
      { id: "i8", label: "設立", value: "令和8年5月22日" },
      { id: "i9", label: "URL", value: "https://www.prcremit.co.jp" },
    ],
    purposes: [
      { id: "p1", text: "資金移動業" },
      { id: "p2", text: "海外送金サービスの企画、開発、運営及び管理" },
      { id: "p3", text: "電子決済システムの企画、開発、提供及び運営" },
      { id: "p4", text: "モバイルアプリケーション及びソフトウェアの企画、開発、提供及び保守" },
      { id: "p5", text: "本人確認業務及び顧客管理システムの企画、運営" },
    ],
    greeting: {
      label: "Message — 代表挨拶",
      name: "代表取締役　黒崎 龍一",
      heading: "「信頼」を基盤に、「速さ」を当たり前に、「世界」をつなぐ。",
      paragraphs: [
        "テクノロジーの進化が世界のあり方を激変させる今、ITシステムやソフトウェアは、すべてのビジネスと人々の可能性を拡張する強力なエンジンです。",
        "私たちはIT開発事業を通じ、単に「システムを構築する」にとどまりません。高度な技術力を核に、以下の3つを追求し、お客様の課題を本質から解決する新たな価値を創造します。",
      ],
      points: ["圧倒的な開発スピード", "強固なセキュリティ", "徹底したユーザー目線の設計"],
      closing: ["国境や環境の壁を打ち破り、あらゆる人がテクノロジーの真価を享受できる未来へ。", "私たちは進化を恐れず、常に先陣を切って挑み続けます。"],
      signature: "代表取締役　黒崎 龍一",
    },
  },
  recruit: {
    eyebrow: "// 06 — Recruit / 採用情報",
    heading: "ともに、未来の\n金融をつくる。",
    intro:
      "PRC Remitでは、世界とつながる資金移動インフラをともに設計する仲間を募集しています。",
    positions: [
      {
        id: "r1",
        title: "システムエンジニア",
        type: "正社員",
        location: "三重県津市（リモート相談可）",
        body: "決済アプリ・海外送金システムの企画から開発、保守までを担当していただきます。",
      },
      {
        id: "r2",
        title: "カスタマーサポート",
        type: "正社員 / パート",
        location: "三重県津市",
        body: "お客様からのお問い合わせ対応や送金手続きのサポートを担当。金融の知識は入社後に丁寧にお教えします。",
      },
    ],
    cta_label: "採用についてお問い合わせ",
    cta_link: "/contact",
  },
  contact: {
    eyebrow: "// 04 — Contact / お問い合わせ",
    heading: "まずは、\nお話を聞かせて\nください。",
    description: "サービスに関するご相談・お見積り・協業のご提案など、お気軽にお問い合わせください。",
    services: ["海外送金サービス", "電子決済システム", "モバイルアプリ開発", "本人確認・顧客管理", "その他"],
  },
  marquee: {
    items: ["PRC REMIT", "GLOBAL PAYMENT INFRASTRUCTURE", "SECURE TRANSACTIONS"],
  },
  footer: {
    tagline: "世界とつながる次世代の資金移動インフラを設計する。",
    lines: ["PRC Remit株式会社", "三重県津市高洲町23番25号", "https://www.prcremit.co.jp"],
  },
};
